import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import recordDomainMoveVisit from './helperFunctions/recordDomainMoveVisit';

// Count full page loads outside React so Strict Mode and navigation cannot recount.
const showDomainMoveNotice = recordDomainMoveVisit();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App showDomainMoveNotice={showDomainMoveNotice} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
